import React from 'react';
import {Box, Button, Grid, Link as ExternalLink} from '@mui/material';
import {Panel} from '../Panel/Panel';
import AccountForm from '../AccountForm/AccountForm';
import {themeColors} from '../../theme/Theme';
import {getPowerBIURL, OpenInCuro} from '../../utils/getCuroURL';
import {useAccountContext} from '../../contexts/AccountContext';
import {AccountDetailsFragment} from '../../schema-types/AccountDetailsFragment';

export const AccountGridItems: React.FC<{
  accountFull?: AccountDetailsFragment | null;
}> = ({accountFull}) => {
  const {account} = useAccountContext();

  return (
    <>
      <Grid item xs={12}>
        <Panel
          color={themeColors.green}
          sx={{
            flexGrow: 1,
          }}
          title="Account details"
        >
          <Box mt={2}>
            <AccountForm
              loadingFullDetails={!accountFull}
              key={accountFull?.id} // refresh component once account full is there
              formFields={[]}
              initialValueOverrides={{
                ...(accountFull || account),
                adviser: accountFull?.adviser?.name,
                owner: accountFull?.owner?.name,
              }}
            />
            <ExternalLink target="_blank" href={getPowerBIURL(account!.curoId)}>
              <Button variant="contained" color="secondary">
                Open account in power BI
              </Button>
            </ExternalLink>
            <OpenInCuro
              variant="contained"
              color="secondary"
              curoType="account"
              curoId={account!.curoId}
              alwaysShow
              sx={{
                marginLeft: '2rem',
              }}
            >
              Open account in curo
            </OpenInCuro>
            <Box mt={2} />
          </Box>
        </Panel>
      </Grid>
    </>
  );
};
